var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 25.1044C19.5286 25.1044 24.821 19.812 24.821 13.2835C24.821 6.75504 19.5286 1.46265 13.0001 1.46265C6.47159 1.46265 1.1792 6.75504 1.1792 13.2835C1.1792 19.812 6.47159 25.1044 13.0001 25.1044Z",
    fill: "#A5B4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0348 9.49005C19.3471 9.91592 19.2773 10.4894 18.9889 10.9319C16.6609 14.5039 14.9127 16.8285 13.8216 18.186C13.1069 19.0752 11.8342 19.1415 11.0218 18.3406C10.0199 17.353 8.61971 15.8856 7.17004 14.089C6.78667 13.6139 6.70741 12.947 7.08219 12.4651C7.37556 12.0879 7.70633 11.7607 8.01099 11.4956C8.57447 11.0054 9.40005 11.115 9.90867 11.662C11.3746 13.2383 12.2562 14.3346 12.2562 14.3346C12.2562 14.3346 13.7225 12.164 16.0776 8.82023C16.4633 8.2726 17.1579 8.01695 17.7377 8.35234C18.1648 8.59945 18.6505 8.9659 19.0348 9.49005Z",
    fill: "#4F46E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3172891db6a21dbc777fa5b5d3dd01c3.svg";
export { ForwardRef as ReactComponent };